import * as constants from './constants';

export const inputFocus = () => ({
    type: constants.INPUT_FOCUS
})
export const inputBlur = () => ({
    type: constants.INPUT_BLUR
})
export const businessCenterClick = () => ({
    type: constants.BUSINESS_CENTER_CLICK
})
export const businessMsgClick = () => ({
    type: constants.BUSINESS_MSG_CLICK
})
export const businessSecurityClick = () => ({
    type: constants.SECURITY_SETTING_CLICK
})
//export const businessVipClick=()=>({
//    type:constants.VIP_CLICK
//})
export const homeSearch = (value) => ({
    type: constants.HOME_SEARCH,
    value: value
})
export const setUserInfo = (value) => ({
    type: constants.SET_USER_INFO,
    value: value
})